import { useInsightActionStore } from '../stores/insightActionStore'

import { registerSessionReset } from '@/features/auth'

export function registerInsightActionSessionReset(): () => void {
  const store = useInsightActionStore()
  return registerSessionReset(() => store.reset())
}
